import './src/css/main.css';
import init from './src/js/main.js';

console.log('Entry point');

init();


// WEBPACK FOOTER //
// ./index.js